export const defaultState = {
  stepper: {
    active: 0,
    steps: {
      0: { isVisited: true, isValid: false },
      1: { isVisited: false, isValid: false },
      2: { isVisited: false, isValid: false },
      3: { isVisited: false, isValid: false },
    },
  },
  mode: "",
  locale: "en",
  currency: "DKK",
  currencies: [],
  loader: {},
  warnings: {},
  admission_tickets: [],
  selectedTimeslots: [],
  texts: {},
  dates: [],
  addons: [],
  summary: {
    selectedDate: null,
    selectedDateIndex: null,
    selectedAdmissionTickets: [],
    selectedAddonTickets: {},
    selectedTimeslot: null,
    discount: 0,
    totals: {},
    selectedCurrency: { id: "DKK", name: "DKK", rate: 1 },
    selectedCCCards: [],
    CCCardsDateRange: { startDate: null, endDate: null },
    selectedGiftCardVariants: {},
  },
  codes: {},
  cart: {},
  loginSessionData: null,
};
